import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import './Accordion.scss';
import IAccordionProps from './AccordionProps';

const Accordion = ({ isOpen = true, children, className }: IAccordionProps) => {
  const [shellHeight, setShellHeight] = useState(isOpen ? 'auto' : '0px');

  const content = useRef<HTMLInputElement>(null);
  const shell = useRef<HTMLInputElement>(null);
  const firstRender = useRef(true);
  const timeout = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (isOpen) {
        timeout.current = handleOpen();
      } else {
        timeout.current = handleClose();
      }
    }

    return () => {
      if (timeout.current) {
        window.clearTimeout(timeout.current);
      }
    };
  }, [isOpen]);

  useEffect(() => {
    setTimeout(() => {
      if (shell.current !== null) {
        shell.current.classList.add('accordion-transition');
      }
    }, 1);
  }, []);

  function handleOpen() {
    if (content.current !== null) {
      setShellHeight(content.current.offsetHeight + 'px');
      return setTimeout(() => setShellHeight('auto'), 500);
    }
  }

  function handleClose() {
    if (content.current !== null) {
      setShellHeight(content.current.offsetHeight + 'px');
      return setTimeout(() => setShellHeight('0'), 50);
    }
  }

  return (
    <div className={classNames('accordion-shell', className)} ref={shell} style={{ height: shellHeight }}>
      <div className="accordion-content" ref={content}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
